import { Link, useNavigate } from "react-router";
import { Layout, Tooltip, Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import {
    UserOutlined,
    LogoutOutlined,
    IdcardOutlined,
    MenuOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import { BrandLogo, useAppMessage } from "@repo/ui";
import { auth } from "@src/api/client";
import { useProfile } from "@src/queries";

const { Header } = Layout;

export type CustomHeaderProps = {
    isMenuOpen?: boolean;
    onToggleMenu?: () => void;
};

export default function CustomHeader({ isMenuOpen = false, onToggleMenu }: CustomHeaderProps) {
    const navigate = useNavigate();
    const notify = useAppMessage();
    const { data, isLoading, isError } = useProfile();

    const profileInfo = !isLoading && !isError && data?.name ? data.name : "Пользователь";

    const onLogout = () => {
        auth.clear();
        notify.success("Вы вышли из аккаунта");
        navigate("/login", { replace: true });
    };

    const profileMenuItems: MenuProps["items"] = [
        {
            key: "profile",
            icon: <IdcardOutlined />,
            label: "Профиль",
            onClick: () => navigate("/profile"),
        },
        // {
        //     key: "settings",
        //     icon: <SettingOutlined />,
        //     label: "Настройки",
        //     onClick: () => navigate("/settings"),
        // },
        { type: "divider" as const },
        {
            key: "logout",
            icon: <LogoutOutlined />,
            danger: true,
            label: "Выйти",
            onClick: onLogout,
        },
    ];

    const logoH = Math.max(28, Math.min(40, 64 - 24));

    return (
        <Header
            className={
                "sticky top-0 z-[10] border-b items-center items-center justify-between w-full flex"
            }
        >
            <div className="flex items-center gap-6">
                <Link to="/" aria-label="На главную" className="block leading-none">
                    <BrandLogo src="/logo.svg" height={logoH} width={120} asChild={false} />
                </Link>

                {
                    <Button
                        variant="outlined"
                        aria-label="Переключить меню"
                        aria-pressed={isMenuOpen}
                        onClick={onToggleMenu}
                        icon={isMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
                    >
                        Меню
                    </Button>
                }
            </div>

            {/* Право: профиль */}
            <div className="flex items-center">
                <Dropdown
                    trigger={["click"]}
                    placement="bottomLeft"
                    menu={{ items: profileMenuItems, style: { width: 180 } }}
                >
                    <Tooltip placement="left" title={profileInfo}>
                        <Button
                            type="default"
                            size="large"
                            icon={<UserOutlined />}
                            aria-label="Меню профиля"
                        />
                    </Tooltip>
                </Dropdown>
            </div>
        </Header>
    );
}
